import * as React from 'react'

const SvgLocation = ({ stroke }) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.0004 11.9703C11.4363 11.9703 12.6004 10.8062 12.6004 9.37026C12.6004 7.93432 11.4363 6.77026 10.0004 6.77026C8.56445 6.77026 7.40039 7.93432 7.40039 9.37026C7.40039 10.8062 8.56445 11.9703 10.0004 11.9703Z" stroke={stroke || "#155EEF"} stroke-width="1.5" />
    <path d="M3.01675 7.85353C4.65842 0.636859 15.3501 0.645193 16.9834 7.86186C17.9418 12.0952 15.3084 15.6785 13.0001 17.8952C11.3251 19.5119 8.67508 19.5119 6.99175 17.8952C4.69175 15.6785 2.05842 12.0869 3.01675 7.85353Z" stroke={stroke || "#155EEF"} stroke-width="1.5" />
  </svg>


)

export default SvgLocation
